import React, {useEffect, useRef, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {useSelector} from 'react-redux';
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'
import notify from '@utils/notify'

import {Button, Card, CardHeader, Col, Container, Modal, Row,} from 'reactstrap'

export default function InvoiceShow() {
  const { id } = useParams()
  const history = useHistory()

  const permissions = useSelector(state => state.getState).permissions

  const [token, setToken] = useState('')
  const [item, setItem] = useState('')
  const [dealer, setDealer] = useState('')
  const [filter, setFilter] = useState('')
  const [types, setTypes] = useState('')

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null,
  })

  useEffect(() => {
      if (id) {
        const grs_token = Cookies.get('grs_token')
        setToken(grs_token)

        const source = axios.CancelToken.source()

        const fetchData = async () => {
          try {
            const response = await axios({
              method: 'GET',
              url: `${constants.API_URL}/invoices/${id}/show`,
              headers: {
                Authorization: `Bearer ${grs_token}`,
              },
              cancelToken: source.token,
            })
            console.log('response :: ', response.data)
            const data = response.data
            setItem(data.data.item)
            setDealer(data.data.dealer)
            setFilter(data.data.filter)
            setTypes(data.data.types)
          } catch (error) {
            if (axios.isCancel(error)) {
              console.log('Request canceled :: ', error)
            } else {
              console.error('error :: ', error)
              notify.warning('Warning', error.response ? error.response.statusText : 'Error occurred!')
            }
          }
        }

        fetchData()

        return () => {
          source.cancel()
        }
      }
  }, [id])

  const paidInvoice = async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${constants.API_URL}/invoices/${id}/paid`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      console.log('response :: ', response.data)
      const data = response.data
      setItem(data.data.item)
      notify.success(data.message)
    } catch (error) {
      console.error('error :: ', error)
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const editInvoice = () => {
    history.push({
      pathname: `/admin/invoice/${id}/edit`
    })
  }

  const downloadInvoice = async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${constants.API_URL}/invoices/${id}/download`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      console.log('response :: ', response.data)
    } catch (error) {
      console.error('error :: ', error)
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const deleteInvoice = async () => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${constants.API_URL}/invoices/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      notify.success(response.data.message)

      setTimeout(() => {
        history.push({
          pathname: '/admin/invoices'
        })
      }, 1500);
    } catch (error) {
      console.error('error :: ', error)
      notify.warning(error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  return (
    <>
      <CardsHeader name="Invoicing" parentName="Invoices Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md={8}>
                    <h1 className="title mb-0">{`Invoice generated for ${dealer.business_name}`}</h1>
                    <Row className="py-3">
                      <Col sm={3}>
                        <small className="text-uppercase text-muted font-weight-bold">Time interval</small>
                      </Col>
                      <Col sm={9}>
                        <h3 className="mb-0">{`${constants.formatDateFullGB(filter.from)} to ${constants.formatDateFullGB(filter.to)}`}</h3>
                      </Col>
                    </Row>
                    <Row className="py-3">
                      <Col sm={3}>
                        <small className="text-uppercase text-muted font-weight-bold">Created At</small>
                      </Col>
                      <Col sm={9}>
                        <h3 className="mb-0">{`${constants.formatDateFullGB(filter.created_at)}`}</h3>
                      </Col>
                    </Row>
                    {item.rules &&
                      <Row>
                        <Col md={3}>
                          <small className="text-uppercase text-muted font-weight-bold">Specific rules at the time running</small>
                        </Col>
                        <Col md={9}>
                          <h3 className="mb-0">
                            {item.rules && item.rules.length > 0 &&
                              item.rules.map((rule, index) => {
                                return <br key={index}>`From ${rule.value_from} deals, value is ${rule.value}`</br>
                              })
                            }
                          </h3>
                        </Col>
                      </Row>}
                    {item.paid_at &&
                      <Row>
                        <Col md={3}>
                          <small className="text-uppercase text-muted font-weight-bold">Mark Paid At</small>
                        </Col>
                        <Col md={9}>
                          <h3 className="mb-0">
                            {constants.formatDateFullGB(item.paid_at)}
                          </h3>
                        </Col>
                      </Row>}
                  </Col>
                  <Col md={4} className="text-right">
                    {permissions.includes('update-invoice') && types[item.type] &&
                      <React.Fragment>
                        <a className="btn btn-sm btn-default" onClick={() => paidInvoice()}>{`Paid`}</a>
                        <a className="btn btn-sm btn-success-red mt-2" onClick={() => editInvoice()}>{`Edit`}</a>
                      </React.Fragment>
                    }
                    <a className="btn btn-sm btn-primary mt-2" onClick={() => downloadInvoice()}>{`Download`}</a>
                    {permissions.includes('delete-invoice') &&
                      <Button className="btn btn-sm btn-success-red mt-2" type="button" onClick={() => setDeleteModal({
                        ...deleteModal,
                        show: true,
                        header: 'Delete invoice',
                        body: 'Are you sure you want to delete this invoice?',
                        onClick: () => deleteInvoice(),
                      })}>
                        {`Delete`}
                      </Button>
                    }
                  </Col>
                </Row>
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {deleteModal.body}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="danger"
              type="button"
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}